// Entry of the customer dashboard build (VITE_RITHMO_CUSTOMER_APP=true; vite.config.ts points index.html here).
// The normal dashboard's entry, src/main.jsx, is unchanged and never loads this.
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import CustomerApp from '../CustomerApp'
import { initAnalytics } from '../analytics'
import './shell/styles.css'

initAnalytics()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <CustomerApp />
    </BrowserRouter>
  </React.StrictMode>,
)
